import React from 'react';
import { FiX, FiArrowRight } from 'react-icons/fi';

const DiffViewerModal = ({ isOpen, onClose, log }) => {
    if (!isOpen || !log) return null;

    const beforeData = log.beforeData || {};
    const afterData = log.afterData || {};

    const allKeys = Array.from(new Set([...Object.keys(beforeData), ...Object.keys(afterData)]));

    const changedKeys = allKeys.filter(key => JSON.stringify(beforeData[key]) !== JSON.stringify(afterData[key]));

    const formatValue = (val) => {
        if (val === null || val === undefined) return <span style={{ color: '#a0aec0', fontStyle: 'italic' }}>None</span>;
        if (typeof val === 'object') return <pre style={{ fontSize: '12px', backgroundColor: '#f7fafc', padding: '8px', borderRadius: '4px', margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{JSON.stringify(val, null, 2)}</pre>;
        return String(val);
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} onClick={onClose}>
            <div style={{ backgroundColor: 'white', width: '90%', maxWidth: '800px', maxHeight: '90vh', borderRadius: '8px', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }} onClick={e => e.stopPropagation()}>
                
                <div style={{ padding: '20px 25px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f7fafc' }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#2d3748' }}>Change Details</h2>
                        <p style={{ margin: '5px 0 0', fontSize: '13px', color: '#718096' }}>
                            Action: <span style={{ fontWeight: 'bold', color: '#4a5568' }}>{log.action}</span> | 
                            Entity: <span style={{ fontWeight: 'bold', color: '#4a5568' }}>{log.entityType} ({log.entityId})</span>
                        </p>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#a0aec0', display: 'flex', padding: '5px' }}>
                        <FiX size={24} />
                    </button>
                </div>

                <div style={{ padding: '25px', overflowY: 'auto', flex: 1 }}>
                    {changedKeys.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px 0', color: '#a0aec0' }}>
                            No modifications detected between before and after states.
                        </div>
                    ) : (
                        <div style={{ border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden' }}>
                            <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
                                <thead style={{ backgroundColor: '#edf2f7', borderBottom: '1px solid #e2e8f0' }}>
                                    <tr>
                                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#4a5568', width: '25%' }}>Field</th>
                                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#4a5568', width: '35%' }}>Before</th>
                                        <th style={{ padding: '12px 16px', textAlign: 'center', color: '#a0aec0', width: '5%' }}></th>
                                        <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#4a5568', width: '35%' }}>After</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {changedKeys.map(key => (
                                        <tr key={key} style={{ borderBottom: '1px solid #edf2f7' }}>
                                            <td style={{ padding: '12px 16px', fontFamily: 'monospace', fontSize: '13px', color: '#4a5568', verticalAlign: 'top', wordBreak: 'break-all' }}>
                                                {key}
                                            </td>
                                            <td style={{ padding: '12px 16px', fontSize: '13px', verticalAlign: 'top' }}>
                                                <div style={{ backgroundColor: '#fff5f5', color: '#9b2c2c', padding: '8px', borderRadius: '4px', border: '1px solid #fed7d7' }}>
                                                    {formatValue(beforeData[key])}
                                                </div>
                                            </td>
                                            <td style={{ padding: '12px 16px', textAlign: 'center', verticalAlign: 'middle', color: '#cbd5e0' }}>
                                                <FiArrowRight style={{ margin: '0 auto' }} />
                                            </td>
                                            <td style={{ padding: '12px 16px', fontSize: '13px', verticalAlign: 'top' }}>
                                                <div style={{ backgroundColor: '#f0fff4', color: '#22543d', padding: '8px', borderRadius: '4px', border: '1px solid #c6f6d5' }}>
                                                    {formatValue(afterData[key])}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    
                    <div style={{ marginTop: '25px', borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
                        <h3 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: 'bold', color: '#4a5568' }}>Context / Reason</h3>
                        <p style={{ margin: 0, fontSize: '13px', color: '#718096', backgroundColor: '#f7fafc', padding: '12px', borderRadius: '4px', border: '1px solid #edf2f7' }}>{log.reason || 'No reason provided.'}</p>
                    </div>
                </div>

                <div style={{ padding: '15px 25px', borderTop: '1px solid #e2e8f0', backgroundColor: '#f7fafc', display: 'flex', justifyContent: 'flex-end' }}>
                    <button onClick={onClose} style={{ padding: '10px 20px', backgroundColor: 'white', border: '1px solid #cbd5e0', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', color: '#4a5568' }}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DiffViewerModal;
